import { render, staticRenderFns } from "./RoleMenu.vue?vue&type=template&id=787813ca&scoped=true"
import script from "./RoleMenu.vue?vue&type=script&lang=js"
export * from "./RoleMenu.vue?vue&type=script&lang=js"
import style0 from "./RoleMenu.vue?vue&type=style&index=0&id=787813ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787813ca",
  null
  
)

export default component.exports